export const getInventory = '/inventory';
export const getInventoryDetail = '/inventory/';
export const addInventory = '/inventory/add-inventory';
export const updateInventory = '/inventory/';
export const addInventories = '/inventory/add-inventories';
export const updateStock = '/inventory/updateStock/';
